import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import ProductHelper from 'src/app/helpers/product-helper';
import UserHelper from 'src/app/helpers/user-helper';
import { NotExecutedHistoryItem } from 'src/app/model/history-item/not-executed-history-item';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import Product from 'src/app/model/product/product';
import Address from 'src/app/model/project/address';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { SubProject } from 'src/app/model/project/sub-project';
import { GetMostRecentNotExecutedHistoryItemControllerRequestService } from 'src/app/services/api/history-item/get-most-recent-not-executed-history-item-controller-request.service';
import { AuthService } from 'src/app/services/auth.service';
import { GetStreetViewMetadataService } from 'src/app/services/google-maps/get-streetview-metadata.service';
import {
  AddressSavedSuccessfullyEvent,
  AddressSaveError,
  ImmoIPChangesService,
} from 'src/app/services/immo-ip-changes/immo-ip-changes-service';
import { SnackService } from 'src/app/services/snack.service';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';
import { STATUS } from '../../../../../../model/project/status';

@Component({
  selector: 'placement-card',
  templateUrl: './placement-card.component.html',
  styleUrls: ['./placement-card.component.scss'],
})
export class PlacementCardComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit, OnChanges
{
  @Input()
  projectPlacement: ProjectPlacement;

  @Input()
  project: Project;

  @Input()
  subProject: SubProject;

  @Input()
  firstProduct: Product;

  @Input()
  fromOldSystem: boolean = false;

  @Input()
  client: boolean = false;

  @Input()
  installerView: boolean = false;

  @Output()
  addressChanged = new EventEmitter<Address>();

  ipBoard: IPBoard;

  hideAddressFields: boolean = true;
  editableAddress: Address;
  notExecutedHistoryItem: NotExecutedHistoryItem;

  saving = false;

  addressPanoId: string;
  isAdmin: boolean = false;

  constructor(
    private snackService: SnackService,
    private getMostRecentNotExecutedHistoryItemControllerRequestService: GetMostRecentNotExecutedHistoryItemControllerRequestService,
    private immoIPChangesService: ImmoIPChangesService,
    private authService: AuthService,
    private getStreetViewMetadataService: GetStreetViewMetadataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateIPBoard();
    this.editableAddress = { ...this.projectPlacement.address };
    this.initializeSubscriptions();
    this.checkAdminAndCalculatePano();
  }

  private initializeSubscriptions(): void {
    this.initializeAddressSavedSubscription();
  }

  private initializeAddressSavedSubscription(): void {
    this.addSubscription(
      this.immoIPChangesService.getAddressSavedSuccessfullyObservable(),
      (event: AddressSavedSuccessfullyEvent) => {
        if (event.subProjectId === this.subProject.id) {
          this.handleAddressSavedSuccessfully(event.address);
        }
      }
    );
    this.addSubscription(
      this.immoIPChangesService.getAddressSaveErrorObservable(),
      (error: AddressSaveError) => {
        if (error.subProjectId === this.subProject.id) {
          this.handleAddressSavedError(error);
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['firstProduct'] != null) {
      this.calculateIPBoard();
      this.getNotExecutedHistoryItem();
    }
  }

  private calculateIPBoard(): void {
    if (ProductHelper.isIPBoard(this.firstProduct)) {
      this.ipBoard = <IPBoard>this.firstProduct;
    } else {
      this.ipBoard = null;
    }
  }

  cancel() {
    this.hideAddressFields = !this.hideAddressFields;
    this.editableAddress = { ...this.projectPlacement.address };
  }

  save() {
    this.saving = true;
    this.addressChanged.emit(this.editableAddress);
  }

  private handleAddressSavedSuccessfully(address: Address): void {
    this.projectPlacement.address = address;
    this.hideAddressFields = !this.hideAddressFields;
    this.snackService.showSuccess('Adres succesvol aangepast');
    this.saving = false;
  }

  private handleAddressSavedError(error: AddressSaveError): void {
    if (error.address != null) {
      this.projectPlacement.address = error.address;
      this.hideAddressFields = !this.hideAddressFields;
    }
    this.saving = false;
  }

  private async getNotExecutedHistoryItem(): Promise<void> {
    if (
      !this.client &&
      this.subProject.id != null &&
      this.subProject.status !== STATUS.DRAFT.valueOf()
    ) {
      this.notExecutedHistoryItem =
        await this.getMostRecentNotExecutedHistoryItemControllerRequestService.getLatestNotExecutedHistoryItem(
          this.subProject.id
        );
    }
  }

  private checkAdminAndCalculatePano(): void {
    this.addSubscription(this.authService.getCurrentUser(), (res) => {
      if (res?.body) {
        this.isAdmin = UserHelper.isAdmin(res.body);
        if (this.isAdmin) {
          this.calculateAddressPano();
        }
      }
    });
  }

  private calculateAddressPano(): void {
    if (this.projectPlacement.address == null) {
      return;
    }
    this.getStreetViewMetadataService
      .getStreetViewLink(this.projectPlacement.address)
      .then((pano: string) => (this.addressPanoId = pano))
      .catch((err) => console.error(err));
  }
}
